import axios from 'axios';
import React, { useEffect, useState } from 'react'
import dorsal from '../../media/dorsal.png';
import { Grid } from '@mui/material';

export const Inscritos = () => {

	const [inscritos, setInscritos] = useState([]);

	const cargarInscritos = () => {

		axios.get("https://www.transbetxi.com/WS/inscritos.php")
			.then(function (response) {
				// console.log(response)
				setInscritos(response.data);
			})
			.catch(function (error) {
				console.error(error)
			})
	}

	useEffect(() => {
		cargarInscritos();
	}, [])

	return (
		<>

			{inscritos.map((inscrito, index) => (
				<Grid container xs={12} sm={8} md={6} xl={4} direction="row" justifyContent="center" alignItems="center" key={index} fontWeight={700}>
					<div className='equipo-card'>
						<div className='equipo-content'>
							<div className='flex-column'>
								<div className="dorsal-img" style={{
									// transform: 'skew(10deg)',
									backgroundSize: 'contain',
									backgroundRepeat: 'no-repeat',
									backgroundImage: `url(${dorsal})`,
									width: '2em',
									height: '2.5em',
									color: inscrito.tipo_maquina == 'Prototipo' ? 'red' : inscrito.tipo_maquina == 'Clasica' ? 'black' : inscrito.tipo_maquina == 'Agria' ? 'blue' : ''
								}}>
									<div> {inscrito.dorsal}</div>

								</div>
							</div>
						</div>
						<Grid container xs={12} sm={10} md={10} xl={10} direction="row" justifyContent="center" alignItems="center" key={index}>
							<div className='equipo-element titlee'> {(inscrito.nombre_equipo)} </div>

							<div className='equipo-element'>Piloto: {(inscrito.nombre_piloto) + ' ' + (inscrito.apellidos_piloto)} </div>
							<div className='equipo-element'>Copiloto: {(inscrito.nombre_copiloto) + ' ' + (inscrito.apellidos_copiloto)} </div>


							<div className='equipo-element'>Categoria: {(inscrito.tipo_maquina)} </div>

						</Grid>

					</div>
				</Grid>

			))}

		</>
	)
}
